import Contact from '../../../models/Contact';

export interface ContactFormFields {
  firstName?: string;
  lastName?: string;
  email?: string;
  mobile?: string;
  dateOfBirth?: string;
  city?: string;
  country?: string;
  salutation?: string;
  custodian?: boolean;
}

export interface ContactFormState {
  formFields: ContactFormFields;
  // Snapshot taken on load/save, so Save Changes can stay disabled until the
  // user actually edits something.
  initialFormFields: ContactFormFields;
  errors?: { [K in keyof ContactFormFields]?: boolean };
  submitting: boolean;
  impersonateDialogOpen: boolean;
}

export interface ContactFormProps {
  contact: Contact | null;
  onContactUpdate: (contact: Contact) => void;
  onContactCreated?: (contactId: string) => void;
  onError: (message: string) => void;
  onSuccess: (message: string) => void;
}

export const SALUTATION_OPTIONS = [
  { value: '', label: '' },
  { value: 'Mr', label: 'Mr' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Ms', label: 'Ms' },
  { value: 'Dr', label: 'Dr' },
  { value: 'Prof', label: 'Prof' },
];
